import { TPendingVerification } from 'views/types/pendingVerification';
import { create, useStore } from 'zustand';

interface IVerificationStore {
  kysItem: TPendingVerification[];
  loading: boolean;
  setKycItem: (tickets: TPendingVerification[]) => void;
  setLoading: (loading: boolean) => void;
}

export const verificationStore = create<IVerificationStore>(set => ({
  kysItem: [],
  loading: false,
  setKycItem: kysItem => set({ kysItem }),
  setLoading: loading => set({ loading }),
}));

export const useVerificationStore = () => useStore(verificationStore);
